import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import AdminLayout from "layouts/admin-layout";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { AuthStatus } from "redux/reducers/Auth";

import {
  APP_PREFIX_PATH,
  AUTH_PREFIX_PATH,
  ADMIN_PREFIX_PATH,
} from "configs/AppConfig";
import useBodyClass from "hooks/useBodyClass";
import useScreenResize from "hooks/Layout/ScreenResize";

import Error404 from "views/auth-views/errors/error-page-1";
import { fetchProfile } from "redux/actions/User";
import { signOutSuccess } from "redux/actions/Auth";
import { AUTH_TOKEN } from "redux/constants/Auth";

const LOGIN_PAGE = "/auth/login";

export const Views = (props) => {
  const admin = true;

  useScreenResize();

  const history = useHistory();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.auth.status);

  const { locale, location, direction } = props;
  const currentAppLocale = AppLocale[locale];
  useBodyClass(`dir-${direction}`);


  useEffect(() => {
    const handleSessionExpired = () => {
      dispatch(signOutSuccess());
    };
    window.addEventListener('auth_session_expired', handleSessionExpired);
    return () => window.removeEventListener('auth_session_expired', handleSessionExpired);
  }, [dispatch]);

  useEffect(() => {
    if (status === AuthStatus.SIGNED_IN) {
      dispatch(fetchProfile());
    }
    if (status === AuthStatus.SIGNED_OUT) {
      localStorage.removeItem(AUTH_TOKEN);
      history.push(LOGIN_PAGE);
    }
  }, [status, dispatch, history]);
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
    >
      <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
        <Switch>
          <Route exact path="/">
            <Redirect to={APP_PREFIX_PATH} />
          </Route>
          <Route path={AUTH_PREFIX_PATH}>
            <AuthLayout direction={direction} />
          </Route>
          <Route path={APP_PREFIX_PATH}>
            <AppLayout direction={direction} location={location} />
          </Route>
          <Route path={ADMIN_PREFIX_PATH}>
            {admin ? (
              <AdminLayout direction={direction} location={location} />
            ) : (
              <Error404 />
            )}
          </Route>
        </Switch>
      </ConfigProvider>
    </IntlProvider>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { locale, direction } = theme;
  const { token } = auth;
  return { locale, token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
